import React from "react";
import meuinssmais from "../../assets/img/meu_inss_mais.svg";
import inss_background from "../../assets/img/inss-transp.svg";

import {
  Tooltip,
  Typography,
  makeStyles,
  Grid,
  Fab,
  Box,
} from "@material-ui/core";


import dayjs from 'dayjs';
import { imprimirCarteira } from "./actions";
import QRCode from "../../shared/component/QRCode";
import { useDispatch, useSelector } from "react-redux";
import AppFooter from "../../shared/template/AppFooter";
import { TK_TIPOS_ACAO_SELECAO_SERVICO, trackServiceSelectORA } from "../../shared/helper/tracker";
import { formatarCpf } from "../../shared/helper/formatadores";
import { openDrawer } from '../../shared/template/drawerPDF/actions';

const useStyles = makeStyles((theme) => ({
  divContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    zIndex: "1",
  },
  divBackgroundImg: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundImage: `url(${inss_background})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    opacity: "0.1",
  },
  inssLogo: {
    backgroundImage: `url(${inss_background})`,
    backgroundRepeat: "no-repeat",
    width: "66px",
    height: "46px",
  },
  img: {
    width: "150px",
    height: "150px",
    borderRadius: "12px",
  },
  imgQrCode: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "20px",
    width: "100%",
  },
  canvasQrCode: {
    position: "relative",
    right: "-10px",
  },
  labelTitle: {
    fontSize: "12px",
    textAlign: "left",
    color: theme.palette.primary.main,
  },
  docTitle: {
    fontSize: "14px",
    textAlign: "left",
  },
  infoTitle: {
    fontSize: "16.8px",
    textAlign: "left",
    fontWeight: "600",
  },
  infoTextoValidade: {
    fontSize: "10px",
    fontWeight: "600",
    textAlign: "center",
  },
  infoTextoQrCode: {
    fontWeight: "500",
    fontSize: "10px",
    textAlign: "center",
  },
  fabStyle: {
    color: theme.apps.avaliacao.tooltip.color,
    fontSize: "24px",
    background: theme.apps.avaliacao.tooltip.backgroundColor,
    position: "absolute",
    bottom: "0px",
    right: "0px",
    "&:hover": {
      background: theme.apps.avaliacao.tooltip.color,
      color: theme.apps.avaliacao.tooltip.backgroundColor,
    },
  },
}));

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

const CarteiraDigital = (props) => {
  const dispatch = useDispatch();
  const fotoBeneficiario = useSelector((state) => state.carteira.foto);
  const urlValidacao = useSelector((state) => state.carteira.urlValidacao);
  const esperandoDownload = useSelector(
    (state) => state.carteira.esperandoDownload
  );
  const usuario = useSelector((state) => state.session.usuario);
  const code = useSelector((state) => state.carteira.code);
  const beneficiosCarteira = useSelector(
    (state) => state.carteira.beneficiosCarteira
  );
  const validade = useSelector((state) => state.carteira.validade);
  const classes = useStyles();
  const tooltipClasses = useStylesBootstrap();

  const capitalizaTexto = (texto) => {
    if (!texto) return "";

    let palavras = texto.split(" ");
    let novoTexto = "";

    for (const palavra of palavras) {
      if (palavra.length > 2) {
        novoTexto +=
          palavra[0].toUpperCase() + palavra.slice(1).toLowerCase() + " ";
      } else {
        novoTexto += palavra.toLowerCase() + " ";
      }
    }

    return novoTexto.trim();
  };

  const downloadCarteira = () => {
    trackServiceSelectORA(TK_TIPOS_ACAO_SELECAO_SERVICO.FUNCIONALIDADE, "Download Carteira Beneficiario");
    dispatch(openDrawer(() => dispatch(imprimirCarteira(code))));
  };

  return (
    <>
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "40px",
        }}
      >
        <div
          style={{
            position: "relative",
            padding: "20px",
            overflow: "hidden",
            maxWidth: "400px",
          }}
        >
          <div className={classes.divBackgroundImg} />
          <div className={classes.divContainer}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className={classes.inssLogo} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: "10px",
                }}
              >
                <Typography
                  variant="h6"
                  style={{ fontSize: "14px", fontWeight: "600" }}
                >
                  MINISTÉRIO DA PREVIDÊNCIA SOCIAL
                </Typography>
                <Typography variant="h6" style={{ fontSize: "12px" }}>
                  INSTITUTO NACIONAL DO SEGURO SOCIAL
                </Typography>
              </div>
            </div>

            <div className={classes.imgQrCode}>
              <img
                id="output"
                src={fotoBeneficiario}
                className={classes.img}
                alt=""
              />
              <QRCode
                className={classes.canvasQrCode}
                text={`${urlValidacao}?code=${code}`}
                size={150}
              />
            </div>

            <Grid container spacing={2}>
              <Grid item xs={6} style={{ padding: "0px" }} />
              <Grid item xs={6} style={{ padding: "10px" }}>
                <Typography className={classes.infoTextoQrCode}>
                  QR Code para consulta dos dados atualizados
                </Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} style={{ marginTop: "20px" }}>
                <Typography className={classes.labelTitle}>
                  Beneficiário
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.docTitle}>
                  CPF: {formatarCpf(usuario.cpf)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography style={{ fontSize: "20.6px", fontWeight: 700 }}>
                  {capitalizaTexto(usuario.nome)}
                </Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} style={{ marginTop: "10px" }}>
                <Typography className={classes.labelTitle}>
                  {beneficiosCarteira && beneficiosCarteira.length > 1
                    ? "Benefícios"
                    : "Benefício"}
                </Typography>
              </Grid>
            </Grid>
            {beneficiosCarteira?.map((beneficio, index) => (
              <Grid container key={index}>
                <Grid item xs={12}>
                  <Typography className={classes.docTitle}>
                    NB: {beneficio.numero}
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ marginBottom: "10px" }}>
                  <Typography className={classes.infoTitle}>
                    {capitalizaTexto(beneficio.especie)}
                  </Typography>
                </Grid>
              </Grid>
            ))}
            <Grid container>
              <Grid item xs={12}>
                <Typography style={{ fontSize: "12px" }}>
                  Emitida em {dayjs().format("DD/MM/YYYY")}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {beneficiosCarteira && (
                  <Typography style={{ fontSize: "12px" }}>
                    Válida até {validade}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid container style={{ padding: "10px" }}>
              <Grid item xs={12}>
                <Typography className={classes.infoTextoValidade}>
                  Não é válido como documento de identificação.
                </Typography>
              </Grid>
            </Grid>
            <img
              style={{ marginTop: "-20px" }}
              src={meuinssmais}
              alt="logo-inss-mais"
              width={250}
              height={100}
            ></img>
          </div>
        </div>
      </Box>

      <div style={{ zIndex: "10", position: "relative" }}>
        <AppFooter
          secondaryText="Voltar"
          primaryText="Carteira em PDF"
          primaryAction={downloadCarteira}
          primaryDisabled={esperandoDownload}
          textAlign="right"
        />
      </div>
    </>
  );
};

export default CarteiraDigital;
